import toolsMarkup from '../markup/tools.js';
import stor from './storage.js';

export default {
  set request(parameters) {
    let xhr;
    let messages = window.appSettings.messages;

    // mess - сообщение, type = true/false - сообщение/ошибка
    const setMessage = (mess, type) => {

      if (type) {
        toolsMarkup.informationtModal4000 = {
          'title': (type) ? 'MESSAGE: ' : 'ERROR: ',
          'message': mess,
          'isMess': type
        };

      } else {
        toolsMarkup.informationtModal = {
          'title': (type) ? 'MESSAGE: ' : 'ERROR: ',
          'message': mess,
          'isMess': type
        };
      }
    };

    const setError = (msg) => {
      setMessage(msg, false);
      // Если есть errorCallback - вызываем
      if (parameters.callbackError && typeof parameters.callbackError === 'function') {
        parameters.callbackError();
      }
    };

    const parseRespCodes = (response) => {
      switch (response.status) {
      case 200:
        parameters.callbackSuccess(response);
        break;
      case 270:
        setMessage(response.message, true);
        parameters.callbackSuccess(response);
        break;
      case 271:
        setError(response.message);
        break;
      case 272:
        parameters.callbackSuccess(response);
        break;
      case 273:
        setError(response.message);
        break;
      case 274:
        setMessage(response.message, true);
        break;
      case 280:
        setMessage(response.message, false);
        document.dispatchEvent(new Event('authError'));
        break;
      case 281:
        parameters.callbackSuccess(response);
        break;
      case 400:
        setError(messages.responseStatus.res400);
        break;
      }
    };

    const array2Data = (dataArr) => {
      let data = '';
      Object.keys(dataArr).forEach((field) => {
        if (!Object.isObject(dataArr[field]))
          data += `&${field}=${dataArr[field]}`;
        else {
          Object.keys(dataArr[field]).forEach((row) => {
            if (!Object.isObject(dataArr[field][row]))
              data += `&${field}[${row}]=${dataArr[field][row]}`;
            else {
              Object.keys(dataArr[field][row]).forEach((column) => {
                data += `&${field}[${row}][${column}]=${dataArr[field][row][column]}`;
              });
            }
          });
        }
      });
      return data.substring(1);
    };
    const xhrLoadHandler = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          let response = '';

          try {
            response = JSON.parse(xhr.response);
          } catch (error) {
            // Вывод ошибки парсинга
            setError(messages.xhrJsonError);
          }

          // Разбираем коды ответа APILopos
          parseRespCodes(response);
        } else {
          // Внутренняя ошибка HTTP
          setError(messages.xhrError);
        }
      }
    };

    const xhrErrorHandler = () => {
      // Ошибка, которую возвращает сервер
      setError(messages.xhrError);
    };

    const xhrTimeoutHandler = () => {
      // Ошибка, которую возвращает сервер
      setError(messages.xhrTimeoutError);
    };

    // const xhrRun = () => {
    xhr = new XMLHttpRequest();

    xhr.addEventListener('load', xhrLoadHandler);
    // Слушаем событие ошибки XHR
    xhr.addEventListener('error', xhrErrorHandler);
    // Слушаем событие таймаута связи
    xhr.addEventListener('timeout', xhrTimeoutHandler);

    xhr.timeout = window.appSettings.xhrSettings.timeout;

    xhr.open(parameters.metod, window.appSettings.xhrSettings.urlApi + parameters.url, true);

    if (typeof stor.data.token !== "undefined" || stor.data.token !== 'null') {
      xhr.setRequestHeader('X-Authorization', stor.data.token);
      // console.log('X-Authorization added');
    };
      // console.log( stor.data.token);
    
    // xhr.send(parameters.data);
    if (parameters.data instanceof Blob)
      xhr.send(parameters.data);
    else if (typeof parameters.data !== 'undefined') {
      xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      if (typeof parameters.data === 'string')
        xhr.send(parameters.data);
      else
        xhr.send(array2Data(parameters.data));
    }
    // };

    // xhrRun();
  },
  set requestYandex(parameters) {
    let xhr;
    let messages = window.appSettings.messages;

    // mess - сообщение, type = true/false - сообщение/ошибка
    const setMessage = (mess, type) => {

      if (type) {
        toolsMarkup.informationtModal4000 = {
          'title': (type) ? 'MESSAGE: ' : 'ERROR: ',
          'message': mess,
          'isMess': type
        };

      } else {
        toolsMarkup.informationtModal = {
          'title': (type) ? 'MESSAGE: ' : 'ERROR: ',
          'message': mess,
          'isMess': type
        };
      }
    };

    const setError = (msg) => {
      setMessage(msg, false);
      // Если есть errorCallback - вызываем
      if (parameters.callbackError && typeof parameters.callbackError === 'function') {
        parameters.callbackError();
      }
    };

    const parseRespCodes = (response) => {
      switch (response.status) {
      case 200:
        parameters.callbackSuccess(response);
        break;
      case 270:
        setMessage(response.message, true);
        parameters.callbackSuccess(response);
        break;
      case 271:
        setError(response.message);
        break;
      case 272:
        parameters.callbackSuccess(response);
        break;
      case 273:
        setError(response.message);
        break;
      case 274:
        setMessage(response.message, true);
        break;
      case 280:
        setMessage(response.message, false);
        document.dispatchEvent(new Event('authError'));
        break;
      case 281:
        parameters.callbackSuccess(response);
        break;
      case 400:
        setError(messages.responseStatus.res400);
        break;
      }
    };


    const xhrLoadHandler = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          let response = '';

          try {
            response = JSON.parse(xhr.response);
          } catch (error) {
            // Вывод ошибки парсинга
            setError(messages.xhrJsonError);
          }

          // Разбираем коды ответа APILopos
          parseRespCodes(response);
        } else {
          // Внутренняя ошибка HTTP
          setError(messages.xhrError);
        }
      }
    };

    const xhrErrorHandler = () => {
      // Ошибка, которую возвращает сервер
      setError(messages.xhrError);
    };

    const xhrTimeoutHandler = () => {
      // Ошибка, которую возвращает сервер
      setError(messages.xhrTimeoutError);
    };

    // const xhrRun = () => {
    xhr = new XMLHttpRequest();

    xhr.addEventListener('load', xhrLoadHandler);
    // Слушаем событие ошибки XHR
    xhr.addEventListener('error', xhrErrorHandler);
    // Слушаем событие таймаута связи
    xhr.addEventListener('timeout', xhrTimeoutHandler);

    xhr.timeout = window.appSettings.xhrSettings.timeout;

    xhr.open(parameters.metod, window.appSettings.xhrSettings.urlContentYCloudLocal + parameters.url, true);

    // xhr.setRequestHeader('X-Authorization', 'YCN_RvhxTbB6prWgj2hV4HcN6YeESmnm2VuVArC3');
      // console.log( stor.data.token);

    xhr.setRequestHeader('Content-type', 'multipart/form-data');
    xhr.send(parameters.data);
    
    // };

    // xhrRun();
  }
};
